import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "f-w-700 pb-1" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "f-w-700" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  value: "",
  disabled: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "f-w-700" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "f-w-700" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "f-w-700" }
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = {
  value: "",
  disabled: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { class: "f-w-700" }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = {
  value: "",
  disabled: ""
}
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "f-w-700" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "f-w-700" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "col-sm-6" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "f-w-700" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "col-sm-6" }
const _hoisted_43 = { class: "f-w-700" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = ["placeholder"]
const _hoisted_46 = { class: "col-sm-6" }
const _hoisted_47 = { class: "f-w-700" }
const _hoisted_48 = { class: "input-group" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = { class: "col-sm-6" }
const _hoisted_51 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_52 = { class: "form-check" }
const _hoisted_53 = {
  class: "form-check-label",
  for: "Single-Item-Select"
}
const _hoisted_54 = { class: "col-sm-6" }
const _hoisted_55 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_56 = { class: "form-check" }
const _hoisted_57 = {
  class: "form-check-label",
  for: "Show-on-Menu"
}

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import { useTaxesStore } from '@/store/management/taxesStore';
import type { Product } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productBasicLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productBasic',
  setup(__props) {

const { t } = useI18n({
  messages: productBasicLanguage
})

const productAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAltLangModal.vue'))

const productStore = useProductsStore()

const taxesStore = useTaxesStore();

onMounted(() => {
    taxesStore.initializeTaxes();
});

const taxList = computed(() => taxesStore.getTaxesList);

onMounted(() => {
    taxesStore.initializeTaxes();
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.emptyBtn = basicData.emptyBtn
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
})

const compState = reactive({
    department: '',
    productNumber: '',
    name: '',
    barcode: '',
    taxRate: '',
    serviceCharge: '',
    alternateName: '',
    alternateName2: '',
    displayOrder: 0,
    emptyBtn: 0,
    singleItemSale: false,
    showOnMenu: false,
    altLangText: ''
})

const departmentList = computed(() => {
    return productStore.getDepartmentList
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}
watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.emptyBtn = basicData.emptyBtn
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        basic: {
            ...tempActiveProduct.value.basic,
            department: newVal.department,
            productNumber: newVal.productNumber,
            name: newVal.name,
            barcode: newVal.barcode,
            taxRate: newVal.taxRate,
            serviceCharge: newVal.serviceCharge,
            alternateName: newVal.alternateName,
            alternateName2: newVal.alternateName2,
            displayOrder: newVal.displayOrder,
            emptyBtn: newVal.emptyBtn,
            singleItemSale: newVal.singleItemSale,
            showOnMenu: newVal.showOnMenu
        }
    } as Product)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const displayEmptyBtnIncrement = () => {
    compState.emptyBtn++
}

const displayEmptyBtnDecrement = () => {
    if (compState.emptyBtn > 0) {
        compState.emptyBtn--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(t)('Product Number')) + " : " + _toDisplayString(compState.productNumber), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_6, _toDisplayString(_unref(t)('Department')), 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "aria-label": _unref(t)('Department'),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.department) = $event))
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)('Department')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentList.value, (department) => {
            return (_openBlock(), _createElementBlock("option", {
              key: department.id,
              value: department.name
            }, _toDisplayString(department.name), 9, _hoisted_9))
          }), 128))
        ], 8, _hoisted_7), [
          [_vModelSelect, compState.department]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_12, _toDisplayString(_unref(t)('Product Name')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Name'),
            maxlength: "32"
          }, null, 8, _hoisted_13), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_16, _toDisplayString(_unref(t)('Barcode')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.barcode) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Name'),
            maxlength: "128"
          }, null, 8, _hoisted_17), [
            [_vModelText, compState.barcode]
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-sm-6" }, null, -1)),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_20, _toDisplayString(_unref(t)('Tax Rate')), 1)
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.taxRate) = $event)),
            class: "form-select",
            "aria-label": _unref(t)('Tax Rate')
          }, [
            _createElementVNode("option", _hoisted_22, _toDisplayString(_unref(t)('Tax Rate')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxList.value.filter(t => !t.serviceCharge), (tax) => {
              return (_openBlock(), _createElementBlock("option", {
                key: String(tax.id),
                value: tax.name
              }, _toDisplayString(tax.name), 9, _hoisted_23))
            }), 128))
          ], 8, _hoisted_21), [
            [_vModelSelect, compState.taxRate]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_26, _toDisplayString(_unref(t)('Service Charge')), 1)
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.serviceCharge) = $event)),
            class: "form-select",
            "aria-label": _unref(t)('Service Charge')
          }, [
            _createElementVNode("option", _hoisted_28, _toDisplayString(_unref(t)('Service Charge')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxList.value.filter(t => t.serviceCharge), (tax) => {
              return (_openBlock(), _createElementBlock("option", {
                key: String(tax.id),
                value: tax.name
              }, _toDisplayString(tax.name), 9, _hoisted_29))
            }), 128))
          ], 8, _hoisted_27), [
            [_vModelSelect, compState.serviceCharge]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_32, _toDisplayString(_unref(t)('Alternative Product Name')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.alternateName) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Name'),
            maxlength: "32"
          }, null, 8, _hoisted_33), [
            [_vModelText, compState.alternateName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_36, _toDisplayString(_unref(t)('Alternative Product Name 2')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.alternateName2) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Name'),
            maxlength: "32"
          }, null, 8, _hoisted_37), [
            [_vModelText, compState.alternateName2]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_40, _toDisplayString(_unref(t)('Alternative Display Language')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Alternative Display Language'),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 8, _hoisted_41), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-sm-6" }, null, -1)),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_43, _toDisplayString(_unref(t)('Display Order')), 1)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: _unref(t)('Threshold'),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.displayOrder) = $event))
          }, null, 8, _hoisted_45), [
            [_vModelText, compState.displayOrder]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_47, _toDisplayString(_unref(t)('Empty Button')), 1)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: _unref(t)('Threshold'),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((compState.emptyBtn) = $event))
          }, null, 8, _hoisted_49), [
            [_vModelText, compState.emptyBtn]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayEmptyBtnDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayEmptyBtnIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "Single-Item-Select",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((compState.singleItemSale) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.singleItemSale]
            ]),
            _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(t)('Single Item Select')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "Show-on-Menu",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((compState.showOnMenu) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.showOnMenu]
            ]),
            _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(t)('Show on Menu')), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_unref(productAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})